export default function createInputAction(type, formId, inputId, additionalPayload) {
  return { type, payload: { ...additionalPayload, formId, inputId } };
}
